// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.
import { defineAsyncComponent } from 'vue';

export function getGlobalComponents() {
  // https://webpack.js.org/guides/dependency-management/#require-context
  // Look for files in the _base components directory
  // Do not look in subdirectories
  // Only include "base-" prefixed .vue files
  const requireComponent = require.context('@/components/_base', false, /base-[\w-]+\.vue$/);

  // For each matching file name...
  return requireComponent.keys().map((fileName) => {
    // Get the PascalCase version of the component name
    const componentName = fileName
      // Remove the "./" from the beginning
      .replace(/^\.\//, '')
      // Remove the file extension from the end
      .replace(/\.\w+$/, '')
      // Split up kebabs
      .split('-')
      // Upper case
      .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
      // Concatenated
      .join('');

    return {
      name: componentName,
      path: fileName.replace(/^\.\//, ''),
    };
  });
}

export function registerGlobalComponents(app) {
  const listGlobalComponents = getGlobalComponents();
  listGlobalComponents.forEach((component) => {
    app.component(
      component.name,
      defineAsyncComponent(() => import(/* webpackChunkName: "globals" */ `@/components/_base/${component.path}`))
    );
  });
}
